/**
 * Sims
 * http://simsrecycling.com
 *
 * Copyright (c) 2017 10up
 * Licensed under the GPL-2.0+ license.
 */

( function( w, doc ) {
	'use strict';

	/**
	 * @description
	 * Accordion
	 * Based on https://github.com/zoltantothcom/vanilla-js-accordion with modifications for targeting multiple accordions with class names instead of id's.
	 *
	 * @class
	 * @param {object} options Options object.
	 * @param {string} options.element The HTML id of the accordion container.
	 * @param {number} [options.openTab=1] Start the accordion with this item opened.
	 * @param {boolean} [options.oneOpen=false] Only one tab can be opened at a time.
	 */


	var Accordion = function( options ) {
		var accordions = document.querySelectorAll( options.element ),
			openTab = options.openTab,
			oneOpen = options.oneOpen || false,
			titleClass = 'js-accordion-title',
			contentClass = 'js-accordion-content';
	
		/**
		 * Initial rendering of the accordion.
		 *
		 * @param {object} accordion The accordion to render.
		 * @param {int} topIndex The index of our accordion.
		 * @returns {void}
		 */
		var render = function( accordion, topIndex ) {
	
			// Attach js classes to headings/buttons
			[].forEach.call( accordion.querySelectorAll( 'dt.heading > .button' ),
				function( button, index ) {
					button.parentElement.classList.add( titleClass );
	
					// Set initial ARIA and ID attributes
					button.setAttribute( 'id', 'tab' + topIndex + '-' + index );
					button.setAttribute( 'aria-selected', 'false' );
					button.setAttribute( 'aria-expanded', 'false' );
					button.setAttribute( 'aria-controls', 'panel' + topIndex + '-' + index );
					button.setAttribute( 'role', 'tab' );
				} );
	
			// Attach js classes to content containers
			[].forEach.call( accordion.querySelectorAll( 'dd.content_wrap' ),
				function( content, index ) {
					content.classList.add( contentClass );
	
					// Set ARIA and ID attributes
					content.setAttribute( 'id', 'panel' + topIndex + '-' + index );
					content.setAttribute( 'aria-hidden', 'true' );
					content.setAttribute( 'aria-labelledby', 'tab' + topIndex + '-' + index );
					content.setAttribute( 'role', 'tabpanel' );
				} );
	
			accordion.addEventListener( 'click', onClick );
	
			// Accordion starts with all tabs closed
			closeAll( accordion );
	
			// Sets the open tab if defined
			if ( openTab ) {
				open( openTab, accordion );
			}
		};
	
		/**
		 * Handles clicks on the accordion.
		 *
		 * @param {object} e Element the click occured on.
		 * @returns {void}
		 */
		var onClick = function( e ) {
			var toggleEl = e.target;
	
			if ( !toggleEl.classList.contains( 'button' ) ) {
				toggleEl = e.target.parentNode;
			}
	
			if ( toggleEl.parentElement.className.indexOf( titleClass ) === -1 ) {
				return;
			}
	
			if ( oneOpen ) {
				closeAll( toggleEl.parentElement );
			}
	
			toggle( toggleEl.parentElement.nextElementSibling );
		};
	
		/**
		 * Expands accordion
		 *
		 * @param {object} el The accordion to show.
		 * @returns {void}
		 */
		var expand = function( el ) {
			var button = el.previousElementSibling.querySelector( '.button' );
	
			el.style.height = el.scrollHeight + 'px';
			el.setAttribute( 'aria-hidden', 'false' );
			button.setAttribute( 'aria-selected', 'true' );
			button.setAttribute( 'aria-expanded', 'true' );
			el.previousElementSibling.classList.add( '-open' );
		};
	
		/**
		 * Collapse accordion
		 *
		 * @param {object} el The accordion to hide.
		 * @returns {void}
		 */
		var collapse = function( el ) {
			var button = el.previousElementSibling.querySelector( '.button' );
	
			el.style.height = '1px';
			el.setAttribute( 'aria-hidden', 'true' );
			button.setAttribute( 'aria-selected', 'false' );
			button.setAttribute( 'aria-expanded', 'false' );
			el.previousElementSibling.classList.remove( '-open' );
		};
	
		/**
		 * Closes all accordion tabs.
		 *
		 * @param {object} accordion The accordion to close all tabs on.
		 * @returns {void}
		 */
		var closeAll = function( accordion ) {
			[].forEach.call( accordion.querySelectorAll( '.' + contentClass ), function( el ) {
				collapse( el );
			} );
		};
	
		/**
		 * Toggles corresponding tab for each title clicked.
		 *
		 * @param {object} el The content tab to show or hide.
		 * @returns {void}
		 */
		var toggle = function( el ) {
			if ( el.style.height === '1px' || el.style.height === '' ) {
				expand( el );
			} else {
				collapse( el );
			}
		};
	
		/**
		 * Returns the corresponding accordion content element by index.
		 *
		 * @param {number} n Index of tab to return
		 * @param {object} accordion element
		 * @returns {object} Targeted accordion
		 */
		var getTarget = function( n, accordion ) {
			return accordion.querySelectorAll( '.' + contentClass )[n - 1];
		};
	
		/**
		 * Opens a tab by index.
		 *
		 * @param {number} n Index of tab to open
		 * @param {object} accordion element
		 * @returns {void}
		 *
		 * @public
		 */
		var open = function( n, accordion ) {
			var el = getTarget( n, accordion );
	
			if ( el ) {
	
				if ( oneOpen ) {
					closeAll();
				}
	
				expand( el );
			}
		};
	
		/**
		 * Closes a tab by index.
		 *
		 * @param {number} n Index of tab to close.
		 * @param {object} accordion element.
		 * @returns {void}
		 *
		 * @public
		 */
		var close = function( n, accordion ) {
			var el = getTarget( n, accordion );
	
			if ( el ) {
				collapse( el );
			}
		};
	
		// Run the render function
		[].forEach.call( accordions, function( el, i ) {
			render( el, i );
		} );
	
		return {
			open: open,
			close: close
		};
	};
	
	// Accordions
	var accordions = new Accordion( {
		element: '.accordion-section > .container > .accordion',
		oneOpen: false
	} );

	// Content Block Accorion
	var contentBlockAccordion = new Accordion( {
		element: '.content-block > .accordion-content',
		oneOpen: false
	} );

	// Leadership Grid Accorion
	var leadershipAccordion = new Accordion( {
		element: '.main > .bio',
		oneOpen: false
	} );

	// Location About Accordion
	var locationAboutAccordion = new Accordion( {
		element: '.content-block > .location-about',
		oneOpen: false
	} );

	// Navigation
	TenUp.navigation( {
		'target': '#js-menu-primary-wrapper',
		'toggle': '#js-menu-toggle',
		'sub_menu_open': 'hover'
	}, function() {
		// Callback
	} );

	// Internal Navigation
	TenUp.navigation( {
		'target': '#js-menu-internal-wrapper',
		'toggle': '#js-internal-toggle',
		'sub_menu_open': 'hover'
	}, function() {
		// Callback
	} );

	TenUp.navigation( {
		'target': '#js-menu-language',
		'toggle': '#js-language-toggle',
		'sub_menu_open': 'hover'
	}, function() {
		// Callback
	} );

	var addLocationClickHandler = function() {
		var locationMenu = document.querySelector( '#js-menu-language' );

		if ( locationMenu ) {
			locationMenu.addEventListener( 'click', function( e ) {
				if ( 'true' === e.currentTarget.getAttribute( 'aria-expanded' ) ) {
					e.currentTarget.setAttribute( 'aria-expanded', 'false' );
				} else {
					e.currentTarget.setAttribute( 'aria-expanded', 'true' );
				}

			} );
		}
	};

	addLocationClickHandler();

	// Move secondary menu items
	var secondaryMenuItems = doc.querySelectorAll( '#js-menu-secondary > .menu-item' );

	[].forEach.call( secondaryMenuItems, function( el ) {
		Util.move( {
			'el': el,
			'appendTo': doc.getElementById( 'js-menu-primary' ),
			'maxWidth': 768
		} );
	} );

	// Move language selector into mobile menu
	Util.move( {
		'el': doc.querySelector( '.nav-language' ),
		'prependTo': doc.querySelector( '#js-menu-primary-wrapper' ),
		'maxWidth': 768
	} );

	// Move search into secondary menu
	Util.move( {
		'el': doc.querySelector( '.nav-primary .search-form' ),
		'appendTo': doc.querySelector( '.nav-secondary' ),
		'minWidth': 768
	} );

	// Modal controls for 'request a quote'
	TenUp.modal( {
		'target': '#quote_modal',
		'trigger': '#modal_opener'
	}, function() {} );

	// Modal controls for location 'get a quote' form.
	TenUp.modal( {
		'target': '#loc_quote_modal',
		'trigger': '#loc_quote_modal_opener'
	}, function() {} );

	// Modal controls for location contact form.
	TenUp.modal( {
		'target': '#loc_contact_modal',
		'trigger': '#loc_contact_modal_opener'
	}, function() {} );

	// Tabs
	TenUp.tabs( {
		'target': '.tab-section'
	}, function() {
		// Callback
	} );

} )( window, window.document );
